import { render, staticRenderFns } from "./stockTransferReport.vue?vue&type=template&id=be1ec30e&"
import script from "./stockTransferReport.vue?vue&type=script&lang=js&"
export * from "./stockTransferReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports